/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-west-2",
    "aws_cognito_identity_pool_id": "us-west-2:920cc009-73f8-47af-b6a6-bc14f7f6930c",
    "aws_cognito_region": "us-west-2",
    "aws_user_pools_id": "us-west-2_It5QeoVEf",
    "aws_user_pools_web_client_id": "1oqbdqr16g2q2jjrce404jnf4o",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_cloud_logic_custom": [
        {
            "name": "quicksight",
            "endpoint": "https://m5qhuvnr0k.execute-api.us-west-2.amazonaws.com/dev",
            "region": "us-west-2"
        }
    ],
    "aws_content_delivery_bucket": "nursa-quicksight-amplify-dev",
    "aws_content_delivery_bucket_region": "us-west-2",
    "aws_content_delivery_url": "https://dg2un74u7sf3m.cloudfront.net"
};


export default awsmobile;
